/* 🤖 this file was generated by script */
export const wiconDocumentSend = {
  name: 'document_send',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 16v1H5V3h10v4"/><path fill="none" stroke="currentColor" stroke-linecap="round" d="M7.03 12.03H16m0 0L13.97 10M16 12.03l-2.03 2.04M7 10h4m-4 4.07h4"/></svg>`,
};
